export default "__VITE_ASSET__BawrVaic__"